module.exports = __webpack_public_path__ + "static/img/logout.9306b858.png";